/* 如果是微服务，需要思考清楚是否还需要使用相同的命名，是否需要带前缀 */
import { basename } from '@/index';
import eventLib from './index';

/* 调用router的useNavigate方法 */
export function dispatchNavigate(path: string | number, extraData?: any) {
  const _path = window.__POWERED_BY_QIANKUN__ ? `${basename}${path}` : path;
  eventLib.dispatch('navigate', _path, extraData);
}
/* 调用公共的window.open */
export function dispatchWindowOpen(path: string) {
  eventLib.dispatch('windowOpen', path);
}

export function dispatchMsgAllRead() {
  eventLib.dispatch('msgAllRead');
}

